import React from "react";
import PropTypes from "prop-types";
import { PageLayout, Content } from "core/layouts";
import {
    BaasicButton,
    BaasicTable,
    QueryDropdown,
    BaasicModal
} from "core/components";
import { defaultTemplate } from "core/hoc";
import { isSome } from "core/utils";
import { PumpEdit, PumpStatusChange, PumpFullEdit, NoteTableRow, PumpsNoteEdit } from "application/pumps/components";

function PumpLandingTemplate({ pumpView }) {
    const {
        facilityStore,
        contentLoading,
        goToFacility,
        tableStore,
        queryUtility,
        initialFacility,
        activeNumber,
        pumpStatus,
        onStatusFilter,
        selectedStatusId,
        statusChangeModal,
        editModal,
        onCreate,
        selectedFacility,
        openFacility,
        authorization
    } = pumpView;

    const status = pumpStatus ? pumpStatus.map(i =>
        <BaasicButton key={i.id}
            className={"btn btn--base u-mar--right--tny " + (i.id == selectedStatusId ? 'btn--primary' : 'btn--ghost')}
            label={i.name}
            onClick={() => onStatusFilter(i.id)}
        />
    ) : null;

    return (
        <PageLayout store={pumpView}>
            <Content loading={contentLoading}>
                <div className="u-mar--bottom--sml">
                    <div className="row">
                        <div className="col col-sml-12 col-med-6 col-lrg-6 col-xxlrg-4">
                            <div className="inputgroup">
                                <div className="inputgroup--main">
                                    <QueryDropdown
                                        placeholder="Select Facility"
                                        queryUtility={queryUtility}
                                        store={facilityStore}
                                        propertyName="facilityId"
                                        onChange={goToFacility}
                                    />
                                    {selectedFacility && 
                                        <div className="u-mar--top--sml">
                                            <a className='type--wgt--regular' onClick={()=> openFacility(selectedFacility.id)}>
                                                <u>{selectedFacility.name}</u>
                                            </a>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-6 col-xxlrg-6">
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-6 col-xxlrg-2 label-text--right">
                            {selectedFacility && <p>Account Number: <strong className="type--wgt--bold">{selectedFacility.masterPatientId}</strong></p>}
                            {selectedFacility && <p>Facility Address: <strong className="type--wgt--bold">{selectedFacility.address}</strong></p>}
                        </div>
                    </div>
                </div>
                {initialFacility && (
                    <React.Fragment>
                        <div className="u-mar--bottom--sml u-clearfix">
                            <div className="u-pull">{status}</div>
                            <div className="u-push">
                                <div className="sform__group__label sis-preview">
                                    {selectedFacility &&
                                        <div>
                                            {selectedFacility.partBOnly && <React.Fragment><p className="label label--info">Part B Only</p></React.Fragment>}
                                            {selectedFacility.pumpsNotSetInitially && <React.Fragment><p className="label label--info">Pumps Not Set Initially</p></React.Fragment>}
                                        </div>
                                    }
                                    <h3>Active pumps: <strong>{activeNumber || 0}</strong></h3>
                                </div>
                            </div>
                        </div>
                        <div className="card--table">
                            <BaasicTable
                                tableStore={tableStore}
                                actionsComponent={authorization && (authorization.delete || authorization.update) ? renderActions : null}
                                customRow={NoteTableRow}
                            />
                        </div>
                        {authorization && authorization.create &&
                            <div className="u-mar--top--med">
                                <div className="row">
                                    <PumpEdit onCreate={onCreate} />
                                    {selectedFacility && <PumpsNoteEdit key={selectedFacility.id} facilityId={selectedFacility.id}/>}
                                </div>
                            </div>
                        }
                        <BaasicModal modalParams={statusChangeModal} className="modal__content modal--sml">
                            <PumpStatusChange />
                        </BaasicModal>
                        <BaasicModal modalParams={editModal} className="modal__content modal--med">
                            <PumpFullEdit />
                        </BaasicModal>
                    </React.Fragment>
                )}
            </Content>
        </PageLayout>
    );
}

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onDelete, onPreview, onStatusChange } = actions;
    if (!isSome(onEdit) && !isSome(onPreview) && !isSome(onDelete) && !isSome(onStatusChange)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                <BaasicButton
                    authorization={
                        authorization ? authorization.update : null
                    }
                    className="btn btn--icon"
                    icon="u-icon u-icon--menu u-icon--sml"
                    label="Change status"
                    onlyIcon={true}
                    onClick={() => onStatusChange(item)}
                ></BaasicButton>
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="Edit"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.delete : null
                        }
                        className="btn btn--icon is-delete"
                        icon="u-icon u-icon--delete u-icon--sml"
                        label="Delete"
                        onlyIcon={true}
                        onClick={() => onDelete(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

PumpLandingTemplate.propTypes = {
    pumpView: PropTypes.object,
    t: PropTypes.func,
};
renderActions.propTypes = {
    item: PropTypes.any,
    actions: PropTypes.any,
    authorization: PropTypes.any
};

export default defaultTemplate(PumpLandingTemplate);
